export default "__VITE_ASSET__Dn57JJlZ__"